import { DisplayOrdersTable } from "./DisplayOrdersTable";
export default DisplayOrdersTable